<template>

	<div class="debug-tool">
        <select v-model="selected" @change="changeChapter(selected)">
          <option disabled value="">Please select one</option>
          <option v-for="chapter in chapters">{{chapter}}</option>
        </select>
        <button v-if="pause" @click="playVideo()">Play</button>
        <button v-if="!pause" @click="pauseVideo()">Pause</button>
        <button @click="setChapter()" :disabled="selected == ''">Set as default</button>
        <button v-if="defaultChapter" @click="removeDefaultChapter()">Reset</button>
        <button @click="forwardVideo()">Forward</button>
        <p>{{currentChapter}}</p>
	</div>

</template>

<script>

export default {

	data () {
		return {
            selected: '',
            defaultChapter: null,
            pause: false
		}
    },
    
    computed: {
        chapters() {
            if(this.timeline !== null) {
                return Object.keys(this.$store.state.episodeData.timeline)
            }
        },
        timeline() {
            return this.$store.state.episodeData
        },
        video () {
            return this.$store.state.video
        },
        episodeData () {
            return this.$store.state.episodeData
        },
        currentChapter () {
            return this.$store.state.currentChapter
        }
        
    },

	methods: {
        changeChapter(value) {
            this.$store.commit('SET_CURRENT_CHAPTER', value)
            this.video.currentTime = this.episodeData.timeline[this.currentChapter].In
        },
        playVideo() {
            this.video.play()
            this.pause = false
        },
        pauseVideo() {
            this.video.pause()
            this.pause = true
        },
        setChapter() {
            if(this.selected) {
                localStorage.setItem('chapter', this.selected)
            }
        },
        removeDefaultChapter() {
            localStorage.removeItem('chapter')
            this.defaultChapter = null
        },
        forwardVideo() {
            this.video.currentTime = this.video.currentTime + 5
        }
	},

	mounted: function() {
        this.$store.commit('SHOW_EPISODE', true),
        this.$store.commit('SHOW_WEBSITE', false)
        
        if(localStorage.getItem('chapter') !== null) {
            this.defaultChapter = localStorage.getItem('chapter')
            setTimeout(() => {
                this.changeChapter(this.defaultChapter)
            }, 500)
            
        }
        
	}
}

</script>

<style lang="scss" scoped>
.debug-tool {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
}
p {
    color: white;
}

</style>



// WEBPACK FOOTER //
// DebugTool.vue?8a1a8164